//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'LinkBtn',
  props: {
    href: {
      type: String,
      default: null
    },
    tooltip: {
      type: String,
      default: null
    }
  },
  methods: {
    onClick (event) {
      if (this.href) {
        window.open(this.href, '_blank')
      }
    }
  }
}
